/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalPatientCategoryAttributes from './hospital-patient-category-attributes';
import HospitalPatientCategoryAttributesDetail from './hospital-patient-category-attributes-detail';
import HospitalPatientCategoryAttributesUpdate from './hospital-patient-category-attributes-update';
import HospitalPatientCategoryAttributesDeleteDialog from './hospital-patient-category-attributes-delete-dialog';

const HospitalPatientCategoryAttributesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalPatientCategoryAttributes />} />
    <Route path="new" element={<HospitalPatientCategoryAttributesUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalPatientCategoryAttributesDetail />} />
      <Route path="edit" element={<HospitalPatientCategoryAttributesUpdate />} />
      <Route path="delete" element={<HospitalPatientCategoryAttributesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalPatientCategoryAttributesRoutes;
